import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import { getUserProfileInfo } from "../api";
import { Col } from "reactstrap";
import { Right } from "./right";
import { Left } from "./left";
import { Alert, Shortcut } from "../shared";
import { setUserInfo } from "../redux";
import { useTranslation } from "react-i18next";
const PanelComp = (props) => {
  const { t } = useTranslation();
  let token = Cookies.get("token");
  const dispatch = useDispatch();
  const [isPhone, setIsPhone] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 992) {
      setIsPhone(true);
    }

    if (!token) {
      props.history.push("/login");
    } else {
      getUserProfileInfo(token)
        .then((res) => {
          dispatch(setUserInfo(res.data.data));
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 5000);
          }
        });
    }
  }, []);

  return (
    <div className={`${isPhone ? "totalWidthMobile" : "totalWidthDesktop"}`}>
      {/* <Col md="12" lg="6" className="right-section col-12"></Col> */}
      <Col md="12" lg="16" className="right-section col-12">
        <Right />
        {isPhone && <Shortcut />}
      </Col>

      {/* <Col md="12" lg="6" className="p-3 left-section">{<Left />}</Col> */}

      {
        !isPhone && <Shortcut />
        // <Alert />
      }
    </div>
  );
};

const Panel = withRouter(PanelComp);

export { Panel };
